import { head, reduce, isEmpty, get, startCase, camelCase, clone } from 'lodash';
import { scaleLinear, select, event } from 'd3';
import moment from 'moment';
import helper from './helper';
import drops from './drops';
import dropLine from './dropLine';
import barLine from './barLine';
import marker from './marker';
import zoom from './zoom';

export default (mouseEvents, containerWidth, isLast, isPrambananConfig) => (selection) => {
  const data = head(selection.data());
  const { destinations } = data;
  const { hidePopover } = mouseEvents;
  const filteredDestinations = destinations.filter((dest) => {
    let isMatchReject = false;
    let isMatchCancel = false;
    let isMatchConfirm = false;
    let isMatchReschedule = false;
    dest.orders.forEach((s) => {
      if (s.status === 'REJECTED') {
        isMatchReject = true;
      } else if (s.status === 'CANCELLED') {
        isMatchCancel = true;
      } else if (s.status === 'CONFIRMED') {
        isMatchConfirm = true;
      } else if (s.status === 'CONFIRMED') {
        isMatchReschedule = true;
      }
    });
    return isMatchReject || isMatchCancel || isMatchConfirm || isMatchReschedule;
  });
  const totalDistance = reduce(destinations, (total, destination) => {
    const distance = !isEmpty(destination.direction) ? destination.direction.distance : 0;
    return total + distance;
  }, 0);

  const toPopoper = text => startCase(camelCase(text));

  const displayTranslate = {
    dx: 220,
    dy: containerWidth - 20,
  };
  const { onLinkClick } = mouseEvents;
  const xScale = scaleLinear()
    .domain([0, totalDistance])
    .range([displayTranslate.dx, displayTranslate.dy]);

  const gProgress = selection.selectAll('.progress').data(d => Array(d));
  const progress = gProgress
    .enter()
    .append('g')
    .classed('progress', true);

  const progressWidth = containerWidth - 200;
  progress
    .append('rect')
    .attr('fill', '#f0f3f5')
    .attr('width', progressWidth)
    .attr('height', 75)
    .attr('y', 0)
    .attr('x', 200)
    .on('click', () => {
      event.stopPropagation();
      hidePopover();
    })
    .attr('stroke-dasharray', () => {
      const dashArray = isLast ? `${(progressWidth * 2) + 50} 0` : `${progressWidth + 75} ${progressWidth + 75}`;
      return dashArray;
    })
    .style('stroke', '#ccc')
    .style('stroke-width', 1);

  const draw = (scale, mEvents) => (sel) => {
    sel
      .call(dropLine(scale, totalDistance))
      .call(barLine(scale))
      .call(drops(scale, mEvents, isPrambananConfig))
      .call(marker(scale, mEvents));
  };

  progress
    .call(draw(xScale, mouseEvents))
    .call(zoom(xScale, draw, mouseEvents, displayTranslate));

  const gPercentage = selection.selectAll('.percentage').data(d => Array(d));
  const percentage = gPercentage
    .enter()
    .append('g')
    .classed('percentage', true);

  percentage
    .append('rect')
    .attr('fill', '#29363D')
    .attr('height', 75)
    .attr('width', 200)
    .attr('stroke', 'white')
    .attr('stroke-dasharray', '200 400')
    .attr('y', 0)
    .attr('x', 2);

  // add percentage
  percentage
    .append('text')
    .attr('transform', 'translate(190, 20)')
    .style('font-weight', 'bold')
    .style('font-family', 'open sans,tahoma,sans-serif')
    .style('fill', '#F0F3F5')
    .style('font-size', '18')
    .attr('text-anchor', 'end')
    .text(d => `${Math.round(d.total_percentage)}%`);

  if (!isPrambananConfig) {
    // shipment number
    percentage
      .append('text')
      .on('click', onLinkClick('number'))
      .on('mouseover', function onHover() {
        select(this).style('text-decoration', 'underline');
      })
      .on('mouseout', function onUnhover() {
        select(this).style('text-decoration', 'unset');
      })
      .attr('transform', 'translate(10, 20)')
      .style('cursor', 'pointer')
      .style('font-family', 'open sans,tahoma,sans-serif')
      .style('font-size', '13px')
      .style('fill', '#F0F3F5')
      .attr('text-anchor', 'start')
      .text(d => `${d.number}`);

    // reg number
    percentage
      .append('text')
      .attr('transform', 'translate(10, 70)')
      .style('font-family', 'open sans,tahoma,sans-serif')
      .style('fill', '#F0F3F5')
      .attr('text-anchor', 'start')
      .text(d => get(d, 'vehicle.reg_no', ''));
  } else {
    // reg number
    percentage
      .append('text')
      .attr('transform', 'translate(10, 20)')
      .style('font-family', 'open sans,tahoma,sans-serif')
      .style('fill', '#F0F3F5')
      .attr('text-anchor', 'start')
      .text(d => get(d, 'vehicle.reg_no', ''));
  }

  // add driver name
  const getDriverName = (d) => {
    let driver = '-';
    const driverObj = helper.get(d, 'driver.name');
    const driverMetadata = helper.get(d, 'metadata.driver_name');

    if (!isEmpty(driverObj)) {
      driver = helper.get(d, 'driver.name');
    } else if (!isEmpty(driverMetadata)) {
      driver = driverMetadata;
    }

    return toPopoper(driver);
  };
  percentage
    .append('text')
    .on('click', onLinkClick('driver'))
    .on('mouseover', function onHover() {
      select(this).style('text-decoration', 'underline');
    })
    .on('mouseout', function onUnhover() {
      select(this).style('text-decoration', 'unset');
    })
    .attr('transform', 'translate(10, 45)')
    .style('cursor', 'pointer')
    .style('font-family', 'open sans,tahoma,sans-serif')
    .style('fill', '#F0F3F5')
    .attr('text-anchor', 'start')
    .text(d => `${getDriverName(d)}`);

  // shipment date
  const getShipmentDate = (d) => {
    const shipmentDateMeta = get(d, 'metadata.shipment_date_string') || null;
    const shipmentCreateDate = get(d, 'created_at') || null;
    const shipmentDeliveryDate = get(d, 'delivery_date', null);
    let formatedDate = shipmentCreateDate;

    if (shipmentDateMeta) {
      formatedDate = shipmentDateMeta;
    }

    if (shipmentDeliveryDate) {
      formatedDate = shipmentDeliveryDate;
    }

    return moment(formatedDate).format('DD MMM YYYY');
  };
  percentage
    .append('text')
    .attr('transform', 'translate(190, 45)')
    .style('font-family', 'open sans,tahoma,sans-serif')
    .style('fill', '#F0F3F5')
    .attr('text-anchor', 'end')
    .text(d => `${getShipmentDate(d)}`);


  // total drop point
  percentage
    .append('text')
    .attr('transform', 'translate(190, 70)')
    .style('font-family', 'open sans,tahoma,sans-serif')
    .style('fill', '#F0F3F5')
    .style('font-size', '13px')
    .attr('text-anchor', 'end')
    .text(() => `${filteredDestinations.length}/${destinations.length} Drop Points`);

  if (isPrambananConfig) {
    // working area
    const getWorkingArea = (d, useFirstWord = true) => {
      const workingAreas = get(d, 'vehicle.metadata.working_area', []);
      const areaText = !isEmpty(workingAreas) ? workingAreas.join(', ') : '-';
      const areaSplited = clone(areaText.split(' '));
      const firstWordArea = head(areaSplited);
      return useFirstWord ? `${toPopoper(firstWordArea)}...` : areaText;
    };
    percentage
      .append('text')
      .attr('transform', 'translate(10, 70)')
      .style('font-family', 'open sans,tahoma,sans-serif')
      .style('fill', '#F0F3F5')
      .style('font-size', '13px')
      .attr('text-anchor', 'start')
      .text(d => getWorkingArea(d));

    percentage
      .append('title')
      .text(d => getWorkingArea(d, false));
  }
};



// WEBPACK FOOTER //
// ./src/views/pages/completion/draw.js